import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { toastr } from "react-redux-toastr";

import qs from "query-string";
import { client, getApiErrorMessage } from "utils/api";

const useGet = ({
  path,
  query,
  context,
  onSuccess,
  onError,
  search = {},
  options = {},
  error_message_enabled = true,
}) => {
  const query_path = qs.stringify(
    { context, ...search },
    { arrayFormat: "bracket", skipNull: true }
  );
  const {
    isLoading: is_loading,
    isFetching: is_fetching,
    isError: is_error,
    isSuccess,
    error,
    data,
    refetch,
  } = useQuery({
    queryKey: query,
    queryFn: () => client.get(`${path}?${query_path}`),
    retry: false,
    keepPreviousData: false,
    ...options,
  });

  useEffect(() => {
    if (isSuccess && typeof onSuccess === "function") {
      onSuccess(data);
    }
  }, [isSuccess, data, onSuccess]);

  useEffect(() => {
    if (is_error) {
      if (error_message_enabled) {
        toastr.error("Błąd", getApiErrorMessage(error));
      }
      onError?.(error);
    }
  }, [is_error, error, onError]);

  return {
    is_loading,
    is_fetching,
    is_error,
    error: getApiErrorMessage(error),
    data: data?.data,
    meta: data?.meta,
    refetch,
  };
};

export default useGet;
